// src/components/home/FounderJourney.jsx
import React, { useState } from "react";
import "./FounderJourney.css";
import FounderStoryModal from "./FounderStoryModal";

const timelineNodes = ["Idea", "Prototype", "BodhAI V1", "BodhAI V2 Beta", "Coming Soon"];

const FounderJourney = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <section className="bvh-founder-journey-section" data-aos="fade-up">
      <div className="bvh-founder-header">
        <h2 className="bvh-founder-title">
          Meet the Creator • <span>Vivek</span>
        </h2>
        <p className="bvh-founder-subtitle">
          Student • Developer • Creator
        </p>
      </div>

      <div className="bvh-founder-timeline">
        {timelineNodes.map((node, index) => (
          <div
            className={`bvh-timeline-node ${node.includes("V2 Beta") ? "active" : ""}`}
            key={index}
          >
            {node}
          </div>
        ))}
      </div>

      <button className="bvh-founder-story-btn" onClick={() => setIsModalOpen(true)}>
        Read Our Story →
      </button>

      <FounderStoryModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </section>
  );
};

export default React.memo(FounderJourney);
